import { Column, Row } from '@simplywallst/ui-core';
import Breadcrumb from '@/components/Breadcrumb';
import { ROUTE_MARKET_HOME } from '@/constants/routes';
import InsightsLogo from '@assets/images/logo/market-insights.svg';
import { Heading, SubHeading, LogoWrapper } from './styled';

const DesktopHeader = () => {
  return (
    <Row>
      <Column colLg={1} colMd={2}>
        <LogoWrapper>
          <InsightsLogo />
        </LogoWrapper>
      </Column>
      <Column colLg={11} colMd={10}>
        <Breadcrumb
          list={[
            {
              name: 'Markets',
              canonicalUrl: '/markets',
              dispatch: { type: ROUTE_MARKET_HOME },
            },
            { name: 'Insights' },
          ]}
        />
        <Heading>Global Market Insights</Heading>
        <SubHeading>
          Stay up to date on the latest global news and understand how it drives
          markets and can impact your investments
        </SubHeading>
      </Column>
    </Row>
  );
};

export default DesktopHeader;
